var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup11924(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.413,
    height: 145.413,
    viewBox: "0 0 145.413 145.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11924",
    "data-name": "Group 11924",
    transform: "translate(-1523.473 -2550.294)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    cx: 72.707,
    cy: 72.707,
    r: 72.707,
    transform: "translate(1523.473 2550.294)",
    fill: "#f4f5f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3400",
    "data-name": "Group 3400"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3399",
    "data-name": "Group 3399"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3274",
    "data-name": "Path 3274",
    d: "M1559.68,2593.77a10.121,10.121,0,0,1,1.7-3.943,8.1,8.1,0,0,1,6.566-3.316q17.574-.045,35.151-.006a8.306,8.306,0,0,1,8.309,8.311c.06,6.13.023,12.261.012,18.391a2.323,2.323,0,0,1-2.306,2.468,2.3,2.3,0,0,1-2.25-2.5q-.009-8.875,0-17.75c0-2.851-1.506-4.36-4.343-4.36h-33.939c-2.844,0-4.33,1.5-4.33,4.361v46.05c0,2.853,1.494,4.35,4.342,4.35q9.447,0,18.894,0a2.279,2.279,0,0,1,2.266,3.143,2.309,2.309,0,0,1-2.336,1.422c-5.4-.011-10.79,0-16.185-.009a32.358,32.358,0,0,1-4.34-.114,8.214,8.214,0,0,1-7.079-6.833,1.9,1.9,0,0,0-.126-.322Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3275",
    "data-name": "Path 3275",
    d: "M1611.314,2659.512c-1.32-.272-2.663-.462-3.956-.83a19.728,19.728,0,1,1,9.258.48c-.671.134-1.347.234-2.021.35Zm-13.582-19.795a15.206,15.206,0,1,0,15.255-15.177A15.211,15.211,0,0,0,1597.732,2639.717Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3276",
    "data-name": "Path 3276",
    d: "M1585.574,2610.848c4.728,0,9.456.008,14.184-.007a2.326,2.326,0,0,1,2.247,1.215,2.255,2.255,0,0,1-1.393,3.244,4.023,4.023,0,0,1-.987.107q-14.078.008-28.154,0a2.384,2.384,0,0,1-2.532-1.557,2.251,2.251,0,0,1,1.953-2.99c.26-.02.522-.015.783-.015Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3277",
    "data-name": "Path 3277",
    d: "M1579.5,2623q4.023,0,8.048,0a2.293,2.293,0,1,1,.022,4.561q-8.119,0-16.238,0a2.291,2.291,0,1,1-.023-4.561Q1575.4,2623,1579.5,2623Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3278",
    "data-name": "Path 3278",
    d: "M1577.878,2603.213c-2.281,0-4.563.01-6.844,0a2.132,2.132,0,0,1-2.046-1.4,1.978,1.978,0,0,1,.489-2.413,2.956,2.956,0,0,1,1.71-.7c4.491-.057,8.982-.042,13.474-.025a2.279,2.279,0,1,1-.011,4.551c-2.257.015-4.515,0-6.772,0Z",
    fill: "#f37521"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3279",
    "data-name": "Path 3279",
    d: "M1610.637,2637.444c0-2.022-.009-3.942,0-5.861a2.315,2.315,0,0,1,1.848-2.445,2.243,2.243,0,0,1,2.7,2.2c.033,1.733.01,3.467.011,5.2v.854c.295.017.544.044.792.045,1.734,0,3.468-.013,5.2.008a2.278,2.278,0,0,1,2.293,1.678,2.115,2.115,0,0,1-.877,2.432,3.078,3.078,0,0,1-1.462.427c-1.685.051-3.372.02-5.059.02h-.849c-.015.307-.038.558-.038.809,0,1.71.008,3.42-.006,5.129a2.281,2.281,0,0,1-2.236,2.438,2.305,2.305,0,0,1-2.319-2.446c-.019-1.686-.005-3.372-.005-5.058v-.872h-.822c-1.687,0-3.373.008-5.059,0a2.255,2.255,0,0,1-2.458-2.276,2.28,2.28,0,0,1,2.47-2.281c1.662-.015,3.325,0,4.988,0Z",
    fill: "#f37521"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11924);
export default __webpack_public_path__ + "static/media/Group 11924.691703a5a8fc84b1a24d14c07ef9c1d2.svg";
export { ForwardRef as ReactComponent };